import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AdminPanel from "./admin/AdminPanel";
import LoginPage from "./admin/LoginPage";
import ThankYouPage from "./pages/ThankYouPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import PrivacyPolicy from "./pages/PrivacyPolicyPage";
const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router basename="/app">
        <Routes>
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/thank_you" element={<ThankYouPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin/*" element={<AdminPanel />} />
          <Route path="/dashboard" element={<Navigate to="/admin" replace />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}
